// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","buttonSecondary":"Button_buttonSecondary__BMBuL","buttonDanger":"Button_buttonDanger__EdSIn"};